import { mapUserDeviceOS } from '@alfa-bank/newclick-helpers/utils/user-agent';
import UAParser from 'ua-parser-js';
export const getOs = (userAgent) => {
    const userAgentParser = new UAParser(userAgent);
    const userAgentData = userAgentParser.getResult();
    const os = userAgentData.os.name;
    const deviceModel = userAgentData.device.model;
    return mapUserDeviceOS(os, deviceModel);
};
